var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { staticClass: "fast-switcher", attrs: { fluid: "" } },
    [
      _vm.idFwMarketgroup
        ? _c("div", [
            _c(
              "div",
              { staticClass: "fast_switch_header" },
              [
                _c("h2", [
                  _vm._v(
                    _vm._s(
                      _vm.marketgroup && _vm.marketgroup.marketgroupname
                        ? _vm.marketgroup.marketgroupname
                        : _vm.event.idfosporttype + " - " + _vm.idFwMarketgroup
                    )
                  )
                ]),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function($event) {
                        return _vm.closeDialog()
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("Dialog.btn.CLOSE")))])]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "events-holder" },
              _vm._l(_vm.marketgroupEvents, function(ev) {
                return _c(
                  "div",
                  {
                    key: ev.idfoevent,
                    staticClass: "event",
                    class: {
                      selected:
                        ev.idfoevent.toString() === _vm.idFoEvent.toString()
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.goToEvent(
                          ev,
                          false,
                          false,
                          false,
                          false,
                          false,
                          _vm.idFwMarketgroup
                        )
                      }
                    }
                  },
                  [
                    _c("v-flex", { staticClass: "names participants" }, [
                      _c("div", { staticClass: "event-info" }, [
                        _c("section", { staticClass: "parent" }, [
                          ev.participantname_away && ev.participantname_home
                            ? _c(
                                "section",
                                { staticClass: "child child-left" },
                                [
                                  _vm.isbig3event
                                    ? [
                                        _c(
                                          "div",
                                          { staticClass: "team-title" },
                                          [
                                            _vm._v(
                                              _vm._s(ev.participantname_away)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "team-title" },
                                          [
                                            _vm._v(
                                              _vm._s(ev.participantname_home)
                                            )
                                          ]
                                        )
                                      ]
                                    : [
                                        _c(
                                          "div",
                                          { staticClass: "team-title" },
                                          [
                                            _vm._v(
                                              _vm._s(ev.participantname_home)
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "team-title" },
                                          [
                                            _vm._v(
                                              _vm._s(ev.participantname_away)
                                            )
                                          ]
                                        )
                                      ]
                                ],
                                2
                              )
                            : _c(
                                "section",
                                { staticClass: "child child-left" },
                                [
                                  _c("div", { staticClass: "team-title" }, [
                                    _vm._v(_vm._s(ev.eventname))
                                  ])
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "section",
                            { staticClass: "child child-right" },
                            [
                              _c("div", { staticClass: "time-holder" }, [
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          !_vm.isDateToday(ev.tsstart) &&
                                          !_vm.isDateTomorrow(ev.tsstart),
                                        expression:
                                          "!isDateToday(ev.tsstart) && !isDateTomorrow(ev.tsstart)"
                                      }
                                    ],
                                    staticClass: "day"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("moment")(
                                          ev.tsstart,
                                          _vm.dateFormats.dayAndMonthUS
                                        )
                                      )
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isDateToday(ev.tsstart),
                                        expression: "isDateToday(ev.tsstart)"
                                      }
                                    ],
                                    staticClass: "day"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("BettingOffer.Today")) + " "
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value: _vm.isDateTomorrow(ev.tsstart),
                                        expression: "isDateTomorrow(ev.tsstart)"
                                      }
                                    ],
                                    staticClass: "day"
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.$t("BettingOffer.Tomorrow"))
                                    )
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "time" }, [
                                  _vm._v(
                                    _vm._s(
                                      _vm._f("moment")(
                                        ev.tsstart,
                                        _vm.dateFormats.longTime
                                      )
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("v-icon", [_vm._v("keyboard_arrow_right")])
                            ],
                            1
                          )
                        ])
                      ])
                    ])
                  ],
                  1
                )
              }),
              0
            )
          ])
        : _vm.isLiveEventPage
        ? _c("div", [
            _c(
              "div",
              { staticClass: "fast_switch_header" },
              [
                _c("h2", [
                  _vm.liveEventsFoIdFoSportType &&
                  _vm.liveEventsFoIdFoSportType[0].fosporttypename
                    ? _c("span", [
                        _vm._v(
                          _vm._s(
                            _vm.liveEventsFoIdFoSportType[0].fosporttypename
                          ) + " - "
                        )
                      ])
                    : _vm._e(),
                  _vm._v("Live Events")
                ]),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    on: {
                      click: function($event) {
                        return _vm.closeDialog()
                      }
                    }
                  },
                  [_c("span", [_vm._v(_vm._s(_vm.$t("Dialog.btn.CLOSE")))])]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "events-holder live" },
              _vm._l(_vm.liveEventsFoIdFoSportType, function(ev) {
                return _c(
                  "div",
                  {
                    key: ev.idfoevent,
                    staticClass: "event",
                    class: {
                      selected:
                        ev.idfoevent.toString() === _vm.idFoEvent.toString()
                    },
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.goToEvent(
                          ev,
                          false,
                          false,
                          false,
                          false,
                          false,
                          _vm.idFwMarketgroup
                        )
                      }
                    }
                  },
                  [
                    _c("v-flex", { staticClass: "names participants" }, [
                      _c(
                        "div",
                        { staticClass: "event-info" },
                        [
                          [
                            _c("section", { staticClass: "parent" }, [
                              ev.homeleadname && ev.awayleadname
                                ? _c(
                                    "section",
                                    { staticClass: "child child-left" },
                                    [
                                      _vm.isbig3event
                                        ? [
                                            _c(
                                              "div",
                                              { staticClass: "team-title" },
                                              [_vm._v(_vm._s(ev.awayleadname))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "team-title" },
                                              [_vm._v(_vm._s(ev.homeleadname))]
                                            )
                                          ]
                                        : [
                                            _c(
                                              "div",
                                              { staticClass: "team-title" },
                                              [_vm._v(_vm._s(ev.homeleadname))]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "team-title" },
                                              [_vm._v(_vm._s(ev.awayleadname))]
                                            )
                                          ]
                                    ],
                                    2
                                  )
                                : ev.player &&
                                  ev.player.find(function(player) {
                                    return !player.type
                                  }) &&
                                  ev.player.find(function(player) {
                                    return !player.type
                                  }).name &&
                                  ev.player &&
                                    ev.player.find(function(player) {
                                      return !player.type
                                    }) &&
                                    ev.player.find(function(player) {
                                      return player.type
                                    }).name
                                ? _c(
                                    "section",
                                    { staticClass: "child child-left" },
                                    [
                                      _c("div", { staticClass: "team-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            ev.player &&
                                              ev.player.find(function(player) {
                                                return !player.type
                                              }) &&
                                              ev.player.find(function(player) {
                                                return !player.type
                                              }).name
                                          )
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "team-title" }, [
                                        _vm._v(
                                          _vm._s(
                                            ev.player &&
                                              ev.player.find(function(player) {
                                                return !player.type
                                              }) &&
                                              ev.player.find(function(player) {
                                                return player.type
                                              }).name
                                          )
                                        )
                                      ])
                                    ]
                                  )
                                : _c(
                                    "section",
                                    { staticClass: "child child-left" },
                                    [
                                      _c("div", { staticClass: "team-title" }, [
                                        _vm._v(_vm._s(ev.eventname))
                                      ])
                                    ]
                                  ),
                              _vm._v(" "),
                              _c(
                                "section",
                                { staticClass: "live-holder child-right" },
                                [
                                  _c("span", { staticClass: "live-badge" }, [
                                    _vm._v("LIVE")
                                  ]),
                                  _vm._v(" "),
                                  _c("v-icon", [_vm._v("keyboard_arrow_right")])
                                ],
                                1
                              )
                            ])
                          ]
                        ],
                        2
                      )
                    ])
                  ],
                  1
                )
              }),
              0
            )
          ])
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-dd9b487c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-dd9b487c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/sports/bettingoffer/fastSwitch.vue
// module id = null
// module chunks = 